import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCustomerMoodThumbUpGreyActive = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M3 10.5V19.5C3 20.0523 3.44771 20.5 4 20.5H6.5V9.5H3.99959C3.44731 9.5 3 9.94772 3 10.5Z",
		fill: "#6B6B6B"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7.5 9.43325V20.5H16.8672C18.1441 20.5 19.2812 19.6917 19.7007 18.4856L21.6137 12.9856C22.2918 11.036 20.8443 9 18.7802 9H15C15 9 15.5 7.2 15.5 6C15.5 4.5 14.8816 3 13 3C10.5 3 10.5 5 10.5 6C10.5 7.33811 8.90842 9.07411 7.5 9.43325Z",
		fill: "#6B6B6B"
	})]
});
export default SvgCustomerMoodThumbUpGreyActive;
